import {
  type AxiosInstance,
  type AxiosResponse,
  HttpStatusCode,
  isAxiosError,
} from "axios";
import { type OwnerAnalyzeFileDownloadRequest } from "@/features/ownerInfo/types";
import fileDownload from "js-file-download";
import { getAttachedFileNameFromHeader } from "@/utils/utils";
import { SendToTrackingService } from "@/api/handlers/errors/SendToTrackingService";

export const getOwnerAnalyzeFileApi = (
  apiClient: AxiosInstance,
  {
    requestId,
    resType,
    fallBackName,
    maxBranchNumber,
  }: OwnerAnalyzeFileDownloadRequest
): void => {
  const endpoint =
    maxBranchNumber == null
      ? `/owner-analyze/download-file/${requestId}/${resType}`
      : `/owner-analyze/download-file/${requestId}/${resType}?max_branch_number=${maxBranchNumber}`;

  apiClient
    .get(endpoint, {
      responseType: "blob",
    })
    .then((res) => {
      const filename = getAttachedFileNameFromHeader(res, fallBackName);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      fileDownload(res.data, filename);
    })
    .catch((error) => {
      if (
        isAxiosError<AxiosResponse>(error) &&
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
      throw error;
    });
};
